import { defineStore } from 'pinia';

export const useDisasterStore = defineStore('DisasterStore', {
  state() {
    return {
        enableDisasterBanner: false,
    };
  },
});
